import { useState } from "preact/hooks";
import { submitUrl, submitHtml } from "../lib/db";

interface Props {
  onClose: () => void;
  onSaved: (id: string) => void;
}

export function CaptureModal({ onClose, onSaved }: Props) {
  const [url, setUrl] = useState("");
  const [title, setTitle] = useState("");
  const [html, setHtml] = useState("");
  const [advanced, setAdvanced] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    const trimmed = url.trim();
    if (!/^https?:\/\//i.test(trimmed)) {
      setError("Enter a full http(s) URL.");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      if (advanced && html.trim()) {
        const { id } = await submitHtml(trimmed, title.trim(), html);
        onSaved(id);
      } else {
        const { id } = await submitUrl(trimmed);
        onSaved(id);
      }
    } catch (e) {
      setError((e as Error).message);
      setBusy(false);
    }
  };

  return (
    <div
      style="position: fixed; inset: 0; background: rgba(0,0,0,0.4); display: flex; align-items: center; justify-content: center; z-index: 40; padding: var(--space-4);"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div class="card" style="width: 100%; max-width: 32rem;" role="dialog" aria-modal="true" aria-label="Add URL">
        <h2 style="margin-top: 0;">Add URL</h2>
        {error && <div class="banner error">{error}</div>}
        <div class="field">
          <label for="cap-url">URL</label>
          <input id="cap-url" type="url" placeholder="https://example.com/article"
            value={url} onInput={(e) => setUrl((e.target as HTMLInputElement).value)}
            autofocus />
        </div>
        <button class="ghost" type="button" onClick={() => setAdvanced((v) => !v)} style="margin-bottom: var(--space-3);">
          {advanced ? "Hide advanced" : "Advanced: submit page HTML"}
        </button>
        {advanced && (
          <>
            <div class="field">
              <label for="cap-title">Title (optional)</label>
              <input id="cap-title" type="text" value={title}
                onInput={(e) => setTitle((e.target as HTMLInputElement).value)} />
            </div>
            <div class="field">
              <label for="cap-html">Page HTML (for paywalled / authenticated pages)</label>
              <textarea id="cap-html" rows={6} value={html}
                onInput={(e) => setHtml((e.target as HTMLTextAreaElement).value)}
                placeholder="Paste the page's HTML. The server will not fetch the URL." />
            </div>
          </>
        )}
        <div class="row" style="justify-content: flex-end; margin-top: var(--space-4);">
          <button onClick={onClose} disabled={busy}>Cancel</button>
          <button class="primary" onClick={submit} disabled={busy}>
            {busy ? <span class="spinner" /> : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
